import React from 'react';
import { rbacService } from 'browser/services/init';
import { Base } from 'lib/cortiUI';
import { AddMembers } from './AddMembers';
export const Actions = ({ team }) => {
    return React.createElement(Base, null, rbacService.teamsCRUD() && React.createElement(AddMembers, { team: team }));
};
